import { DependencyList, MutableRefObject, useEffect, useRef } from 'react';

/**
 * useCurrentRef
 *
 * Returns a ref object that is updated when the value changes
 * Good for holding a value thats update doesn't need to trigger
 * a re-render
 *
 * @param value - Value to track
 * @param deps - Optional array of dependencies to pass to the useEffect instead of the value
 * @returns A ref object
 */
export const useCurrentRef = <T>(
    value: T,
    deps?: DependencyList,
): MutableRefObject<T> => {
    const ref = useRef(value);

    useEffect(() => {
        ref.current = value;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps || [value]);

    return ref;
};
